<template>
  <div class="mb-16">
    <validation-observer ref="observer" v-slot="observerProps">
      <items-remaining :show="((observerProps.touched && observerProps.invalid) || (isBackFromConfirmation && observerProps.invalid)) && isIntersecting"
                       :numberOfRemaining="countInvalidFields(observerProps.fields)"
      />
      <register-form-charibon
        :pickup-request-cut-off-time-offset-in-hours="-1"
        :max-number-of-packages="maxNumberOfPackages"
        v-intersect="onIntersect"
      >
        <template #mail-address>
          <vb-mail-address
            :form-items-setter="setMemberFormItems"
            :form-items-getter="{
              email: getMemberFormItems.email,
              isAgreedCreateMainSiteAccount: getMemberFormItems.isAgreedCreateMainSiteAccount
            }"
          />
        </template>
        <template #email-subscription-for-charibon>
          <vb-form-row item-name="メール配信" :required="true">
            <template #input>
              <vb-email-subscription
                  :form-items-setter="setMemberFormItems"
                  :is-required-email-subscription="false"
                  :form-items-getter="{emailSubscriptionCode: getMemberFormItems.emailSubscriptionCode}"
               />
            </template>
          </vb-form-row>
        </template>
        <template #terms-of-service-for-charibon>
          <vb-form-row item-name="利用規約/個人情報の取り扱い" :required="true">
            <template #input>
              <div class="px-3 px-md-0 mb-md-0">
                <vb-terms-of-service
                  :form-items-setter="setMemberFormItems"
                  :form-items-getter="{
                    isAgreedWithTermsAndPrivacy: getMemberFormItems.isAgreedWithTermsAndPrivacy,
                    isAgreedCreateMainSiteAccount: getMemberFormItems.isAgreedCreateMainSiteAccount,
                    campaignCode: getBuyFormItems.campaignCode,
                  }"
                />
              </div>
            </template>
          </vb-form-row>
        </template>
        <template #button>
          <v-row justify="center">
            <v-btn
              class="secondary white--text text-subtitle-1 text-md-h6 text-md-h6"
              :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
              :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
              :disabled="observerProps.invalid"
              @click="goToConfirm"
            >
              内容を確認する
            </v-btn>
          </v-row>
        </template>
      </register-form-charibon>
    </validation-observer>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GtmOnVue from "../../../libs/gtmOnVue.js";
import RegisterFormCharibon from "../../template/register-form-charibon.vue";
import VbEmailSubscription from "../../molecules/form/agreed/vb-email-subscription.vue";
import VbMailAddress from "../../molecules/form/vb-mail-address.vue";
import ItemsRemaining from "../../molecules/items-remaining.vue";
import VbFormRow from "../../molecules/buy/vb-form-row.vue"
import VbTermsOfService from "../../molecules/form/agreed/vb-terms-of-service.vue";
import CharibonEntryConfirm from "./charibon-entry-confirm.vue";

export default {
  name: "charibon-entry-form",
  components: {
    RegisterFormCharibon,
    VbEmailSubscription,
    VbMailAddress,
    ItemsRemaining,
    VbFormRow,
    VbTermsOfService,
  },
  data() {
    return {
      maxNumberOfPackages: VueConfig.sell.maxNumberOfPackagesForCharibon,
      cdnUrl: VueConfig.cdn_url,
      isIntersecting: false,
    }
  },
  provide: function () {
    //子コンポーネントでエラーをセットするため
    return {
      setErrors: this.observeSetErrors
    }
  },
  created() {
    this.setBuyFormItems({name: 'site_code', value: this.$siteCode});

    // id 支援先団体
    const id = this.$route.query.id;
    if (id) {
      this.setBuyFormLabels({name: 'requestParamSupportGroupId', value: id});
    }

    // kcode or couponcode クーポン
    const kCode = this.$route.query.kcode;
    if (kCode) {
      this.setBuyFormItems({name: 'campaignCode', value: kCode});
    }
    const couponCode = this.$route.query.couponcode;
    if (couponCode) {
      this.setBuyFormItems({name: 'campaignCode', value: couponCode});
    }

    if (this.$route.params.hasOwnProperty('emailSubscriptionCode')) {
      const becomeNewsletterSubscriber = this.$route.params.emailSubscriptionCode === true;
      this.setMemberFormItems({name: 'emailSubscriptionCode', value: becomeNewsletterSubscriber});
    } else {
      this.setMemberFormItems({name: 'emailSubscriptionCode', value: true});
    }

    const vboffice = this.$route.query.vboffice;
    if (vboffice == VueConfig.sell.VbOfficeCodeCharibon) {
      this.setBuyFormItems({name: 'vbOfficeCode', value: vboffice});
      this.maxNumberOfPackages = VueConfig.sell.maxNumberOfPackagesForCharibonVbOffice;
    }

    GtmOnVue.sendGAEventCharibonOfferAll(id, (kCode ? kCode : couponCode), vboffice);

    // URLパラメータの値をセット
    this.setUrlParameterValues().then((status) => {
      // 入力補完がある場合はバリデーションを実行
      if(status) {
        this.$refs.observer.validate();
      }
    });
  },
  methods: {
    ...mapActions({
      setMemberFormItems: 'member/updateFormItems',
      setBuyFormItems: 'buy/updateFormItems',
      setBuyFormLabels: 'buy/updateFormLabels',
      isValidatePickupTime: 'buy/isValidatePickupTime',
      retrieveCouponCode: 'buy/retrieveCouponCode',
      setUrlParameterValues: 'buy/setUrlParameterValues',
    }),
    async goToConfirm() {

      // 同じメールでの再申し込みチェック
      const result = await this.validDuplicateApplicationBySameMail()
      if (!result) {
        this.observerErrorHandle("メールアドレス", "取引中のお申込みがあるため新たにお申込み依頼はできません。");
        return
      }

      //クーポンチェック
      const result_coupon = await this.retrieveCouponCode();
      if (!result_coupon.status) {
        this.observerErrorHandle("クーポンコード", result_coupon.errorMsg);
        return
      }

      //集荷日チェック
      const response_pickup_date = await this.isValidatePickupTime()
      if (!response_pickup_date) {
        this.observerErrorHandle("日にち", "ご指定の集荷希望日は選択できません。");
        return
      }

      this.$router.push({name: "CharibonEntryConfirm", query: this.$route.query});
    },
    async validDuplicateApplicationBySameMail() {
      const response = await axios.post("/api/ajax/mail/trading", {
        mail: this.getMemberFormItems.email,
        site_code: this.$siteCode,
      }).catch((err) => {
        console.error("Catch" + err);
        return false;
      });
      if (response) {
        return !response.data.result
      }
      return false
    },
    observeSetErrors(name, errorMessage) {
      let params = {};
      params[name] = errorMessage;
      this.$refs.observer.setErrors(params);
    },
    scrollBehavior(position) {
      this.$vuetify.goTo(position, {
        duration: 300,
        offset: window.innerHeight / 2,
        easing: 'easeInOutCubic'
      })
    },
    scrollTargetNode(name) {
      return this.$refs.observer.refs[name].$el;
    },
    observerErrorHandle(name, message) {
      this.observeSetErrors(name, message);
      this.scrollBehavior(this.scrollTargetNode(name));
    },
    onIntersect (entries, observer) {
      this.isIntersecting = entries[0].isIntersecting
    },

    fetchUniqueQuery (param) {
      let uniqueQuery;
      if(param) {
        if(typeof param == 'string') {
          uniqueQuery = param.toLowerCase();
        } else if (param[0]) {
          uniqueQuery = param[0].toLowerCase();
        } else {
          uniqueQuery = null;
        }
      }
      return uniqueQuery;
    },
  },
  computed: {
    ...mapGetters({
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      getMemberFormItems: 'member/getFormItems',
    }),
    headingBgColor() {
      return this.$vuetify.breakpoint.mdAndUp ? 'transparent' : 'accent3';
    },
    headingTextColor() {
      return this.$vuetify.breakpoint.mdAndUp ? 'primaryTextColor' : 'white';
    },
    headingPadding() {
      return this.$vuetify.breakpoint.mdAndUp ? 'pa-0' : 'pa-0 pl-4';
    },
    countInvalidFields: function () {
      return function (fields) {
        let count = 0;
        for (let key of Object.keys(fields)) {
          !fields[key].valid && count++
        }
        return count;
      }
    },
    isBackFromConfirmation() {
      return this.$route.params.isBackButton;
    },
  },
  mounted() {
    if (this.$route.params.validate_on_load) {
      this.$refs.observer.validate();
    }
    // 確認画面で集荷日時のエラーになった場合に表示する
    if (this.$route.params.pickup_date_error) {
      this.observerErrorHandle("日にち", "ご指定の集荷希望日は選択できません。");
    }
  },
}
</script>

<style scoped lang="scss">
.fixed-width {
  max-width: 1024px;
}
 
</style>